import { useNavigate } from 'react-router-dom';
import './index.scss';

export default function SharkButton(props) {
  const { children, to } = props;
  const navigate = useNavigate();
  
  return (
    <div className="shark-button" onClick={() => navigate(to || '/login')}>
      <button>
        {children}
        <span></span>
      </button>
    </div>
  )
}